import * as api from "../../core/net/api";

import MainContainer from "./MainContainer";
import GalleryManager from "../../core/gallery/GalleryManager";
import AppSettings from "../../core/AppSettings";
import BrowserCheck from "../../core/lib/BrowserCheck";
import CustomError from "../../core/skins/Core_Metal/Error";
import Error from "./Error";

// const DESKTOP_WIDTH_BREAKPOINT = 600;

class App extends BrowserCheck {
  constructor({ settings, handoverKey, rootElement }) {
    super();

    this.settings = settings; // options and callbacks passed in from appParams.js
    this.rootElement = rootElement;
    this.options = settings.options || {};

    AppSettings.handoverKey = handoverKey;
    AppSettings.environment = this.options.env || "dev";
    AppSettings.passThrough = this.options.passthrough;
    AppSettings.instanceSettings = settings;
    AppSettings.emailAddress = this.options.emailAddress;
    AppSettings.handback = this.options.handback;
    AppSettings.startHidden = this.options.startHidden;

    // Hide page if startHidden is true
    if (AppSettings.startHidden === true) {
      this.rootElement.classList.add("hide");
    }
  }

  start() {
    console.log(
      "%cApp Started... ",
      "font-family:Arial;font-size: 12px; color: orange"
    );
    this.updateSizeClasses();
    this.rootElement.innerHTML = "Loading...";
    window.addEventListener("resize", (e) => this.updateSizeClasses(e));

    const { width, height } = this.rootElement.getBoundingClientRect();

    const that = this;

    //load designer
    async function loadDesigner() {
      const response = await api.getDesigner(AppSettings.handoverKey);
      if (!response) {
        //TODO handle bad response
        return;
      }
      AppSettings.designerSettings = response;

      if (that.options.orientation) {
        AppSettings.designerSettings.Orientation.Type = this.options.orientation;
      }

      if (that.options.languageId) {
        //AppSettings.designerSettings.Language = (response.Language) ? response.Language : that.options.languageId;
        AppSettings.designerSettings.Language = response.Language
          ? that.options.languageId
          : response.Language; //prioritise appParams option
      }

      return response;
    }

    async function loadGalleries() {
      if (!AppSettings.designerSettings.Galleries.URL) {
        return;
      }
      const galleryManager = new GalleryManager();
      return await galleryManager.loadGalleries(
        AppSettings.designerSettings.Galleries.URL
      );
    }

    //create client
    async function createClient() {
      const client = await api.createClient(AppSettings.handoverKey, {
        LanguageId: AppSettings.designerSettings.Language,
      });
      AppSettings.client = client;
      AppSettings.clientId = client.CardImageId;
      return client;
    }

    //load language data
    async function loadLanguage() {
      const res = await api.getLanguage(
        AppSettings.handoverKey,
        AppSettings.designerSettings.Language
      );
      AppSettings.Language = res || {};
      AppSettings.Language.LanguageId = AppSettings.designerSettings.Language;
      return res;
    }

    // check browser if internet explorer shout out for chrome, edge, firefox, safari
    const checkIEBrowser = async () => {
      if (this.isInternetExplorerBrowser()) {
        await new CustomError(
          this.rootElement,
          `It looks like you're using Internet Explorer, <br> Please consider updating your browser to  (EDGE, Chrome, Firefox, Safari) and enjoy an optimal experience.`,
          {
            errorTitle: `Unsupported Browser`,
          }
        );
      }
    };

    // call chain of requests
    loadDesigner()
      .then(createClient)
      .then(loadGalleries)
      .then(loadLanguage)
      .then(
        () => {
          /*if (AppSettings.isTouchDevice()) {
				this.rootElement.classList.add('mobile');
			}*/

          const mainContainer = new MainContainer(this.rootElement);

          mainContainer.show();

          checkIEBrowser();
        },
        (error) => {
          console.log("error", error);
          new Error(this.rootElement);
        }
      );
  }

  handlerError(error) {
    if (this.settings.callbacks && this.settings.callbacks.onError) {
      this.settings.callbacks.onError(error);
    }

    throw new Error(error);
  }

  resetSizeClasses() {
    //have to do these separately because IE11 won't accept multiples!
    this.rootElement.classList.remove("small");
    this.rootElement.classList.remove("medium");
    this.rootElement.classList.remove("large");
  }

  /* -----------------------------------------------------------------------
	Sets the class of the root element (aam-designer-element) based on
	its dimensions and being a touch device or not
	------------------------------------------------------------------------*/
  //handleResize() {
  updateSizeClasses() {
    /*-----------------------------------------------------------------------------------
		get dimensions of aam-designer. We need to use this rather than its parent, because aam-designer
		has min/max dimensions (in css) that override the parent container dimensions
		-----------------------------------------------------------------------------------*/
    const { width, height } = this.rootElement.getBoundingClientRect();
    const isTouch = AppSettings.isTouchDevice() === true;

    this.rootElement.classList.add(isTouch ? "mobile" : "desktop");

    //console.log('main dimensions ' + Math.floor(width) +' x ' + Math.floor(height));

    this.resetSizeClasses();

    if (isTouch) {
      //mobile--------------------------------------------------------

      if (width <= height) {
        //portrait

        this.rootElement.classList.add("portrait");
        this.rootElement.classList.remove("landscape");

        if (width <= 560) this.rootElement.classList.add("small");
        if (width > 560 && width <= 780)
          this.rootElement.classList.add("medium");
        if (width > 780) this.rootElement.classList.add("large");
      } else {
        //landscape

        this.rootElement.classList.remove("portrait");
        this.rootElement.classList.add("landscape");

        if (height <= 559) this.rootElement.classList.add("small");
        if (height > 560 && height < 779)
          this.rootElement.classList.add("medium");
        if (height > 780) this.rootElement.classList.add("large");
      }
    } else {
      //desktop----------------------------------------------------------------

      if (width <= 749) this.rootElement.classList.add("small");
      if (width > 749 && width <= 955) this.rootElement.classList.add("medium");
      if (width > 955) this.rootElement.classList.add("large");

      if (width <= height) {
        //portrait

        this.rootElement.classList.add("portrait");
        this.rootElement.classList.remove("landscape");

        this.resetSizeClasses();

        if (width <= 425) this.rootElement.classList.add("small");
        if (width > 425 && width <= 515)
          this.rootElement.classList.add("medium");
        if (width > 515) this.rootElement.classList.add("large");
      } else {
        //landscape

        this.rootElement.classList.remove("portrait");
        this.rootElement.classList.add("landscape");
      }
    }
  }
}

export default App;
